export default "/_next/static/chunks/fonts/lato-400-be36596da218e1eec01c5c600b1c13ef.woff2";